export const pageContainerSx = {
  width: "100%",
  minHeight: "100vh",
  px: { xs: 2, sm: 3, md: 4 },
  py: { xs: 2, sm: 3 },
};

export const pageHeaderSx = {
  fontSize: {
    xs: "1.5rem !important",
    sm: "1.75rem !important",
    md: "2rem !important",
  },
  fontWeight: 800,
  lineHeight: 1.1,
};

export const pageLoadingSx = {
  width: "100%",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: 3,
};

export const sectionTitleSx = {
  fontFamily: "'Inter var', sans-serif",
  mb: 0,
  color: "#1e293b",
  fontSize: "18px",
  fontWeight: 500,
};

export const sectionSubtitleSx = {
  mt: 0.5,
  fontSize: 13,
  color: "text.secondary",
};

export const infoCardSx = {
  overflow: "hidden",
  p: 0,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  padding: 2.25,
};

export const cardHeaderSx = {
  display: "flex",
  alignItems: { xs: "flex-start", md: "center" },
  justifyContent: "space-between",
  flexDirection: "row",
  gap: 2,
};

export const detailsMetricsRowSx = {
  mt: 1.4,
  display: "flex",
  flexWrap: "wrap",
  columnGap: 3,
  rowGap: 1.2,
};

export const detailsMetricItemSx = {
  minWidth: 0,
  flex: "0 1 170px",
};

export const detailsMetricValueContentSx = {
  flex: 1,
  minWidth: 0,
};

export const detailsSupplementaryRowSx = {
  mt: 3,
  display: "flex",
  flexWrap: "wrap",
  alignItems: "start",
};

export const detailsTypeBlockSx = {
  minWidth: 0,
  flex: {
    xs: "1 1 100%",
    lg: "0 1 156px",
  },
};

export const detailsDescriptionBlockSx = {
  minWidth: 0,
  flex: {
    xs: "1 1 100%",
    lg: "1 1 320px",
  },
};

export const detailsChannelsBlockSx = {
  minWidth: 0,
};

export const dispatchConfigSectionSx = {
  mt: 1.6,
};

export const dispatchConfigTitleSx = {
  fontFamily: "'Inter var', sans-serif",
  color: "#64748b",
  mb: 0.75,
  fontSize: 13,
  fontWeight: 500,
};

export const dispatchConfigCardsRowSx = {
  display: "flex",
  flexWrap: "wrap",
  gap: 0.75,
};

export const dispatchConfigCardSx = {
  border: "1px solid #d6dee8",
  borderRadius: "10px",
  backgroundColor: "#f7f7fc",
  px: 1.1,
  py: 0.65,
  minWidth: 98,
  maxWidth: 320,
};

export const labelSx = {
  fontFamily: "'Inter var', sans-serif",
  fontSize: 12,
  color: "#64748b",
  mb: 0,
};

export const valueSx = {
  fontFamily: "'Inter var', sans-serif",
  fontSize: "15px",
  color: "#1e293b",
  fontWeight: "100 900",
  display: "block",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const badgeSx = {
  fontFamily: "'Inter var', sans-serif",
  fontSize: "14px",
  color: "#ffffff",
  fontWeight: "400",
}

export const descriptionValueSx = {
  ...valueSx,
  fontWeight: 400,
  lineHeight: 1.25,
};

export const metricValueRowSx = {
  display: "flex",
  alignItems: { xs: "flex-start", sm: "center" },
  gap: 0.6,
  minHeight: 24,
};

export const metricValueIconSx = {
  width: 22,
  height: 22,
  color: "#64748b",
  flexShrink: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    width: 18,
    height: 18,
    fontSize: 18,
  },
};

export const statusValueSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
};

export const statusTextSx = {
  fontWeight: 700,
  lineHeight: 1.2,
};

export const templatePreviewCardSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  boxShadow: "none",
  overflow: "hidden",
  height: { xs: 360, sm: 380, lg: 396 },
  display: "flex",
  flexDirection: "column",
};

export const templatePreviewCardContentSx = {
  height: "100%",
};

export const templateDescriptionSx = {
  mt: 0.35,
  fontSize: 13,
  lineHeight: 1.45,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const previewFrameSx = {
  minHeight: 0,
  flex: 1,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "rgba(248, 250, 252, 0.78)",
  overflow: "hidden",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  "& > *": {
    flex: 1,
    minHeight: 0,
  },
};

export const previewEmptySx = {
  minHeight: 120,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  px: 2,
};

export const previewModalFrameSx = {
  height: { xs: 320, md: 420 },
  maxHeight: "65vh",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "rgba(248, 250, 252, 0.78)",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  "& > *": {
    flex: 1,
    minHeight: 0,
  },
};

export const templateChannelSx = {
  px: 1,
  py: 0.4,
  borderRadius: "999px",
  bgcolor: "rgba(129, 66, 252, 0.08)",
  color: "primary.main",
  fontSize: 12,
  fontWeight: 800,
  whiteSpace: "nowrap",
};

export const compactTemplateTabsSx = {
  minHeight: 34,
  borderBottom: "1px solid #e2e8f0",
  "& .MuiTabs-indicator": {
    height: 2,
    borderRadius: 2,
  },
  "& .MuiTab-root": {
    minHeight: 34,
    minWidth: "auto",
    px: 1.1,
    py: 0.5,
    fontSize: 13,
    textTransform: "none",
    fontWeight: 600,
    color: "#475569",
  },
  "& .MuiTab-root.Mui-selected": {
    color: "#0f172a",
    fontWeight: 700,
  },
};

export const modalTemplateTabsSx = {
  minHeight: 36,
  "& .MuiTab-root": {
    minHeight: 36,
    px: 1.5,
    py: 0.75,
    textTransform: "none",
    fontWeight: 700,
  },
};

export const dispatchTableCardSx = {
  mt: 3,
  p: { xs: 2, sm: 3 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  boxShadow: "none",
};

export const refreshButtonSx = {
  minWidth: 100,
  height: 40,
  borderRadius: 999,
  border: "1px solid",
  borderColor: "grey.300",
  backgroundColor: "#fff",
  "&:hover": {
    backgroundColor: "grey.200",
    borderColor: "grey.400",
  },
  "&:active": {
    backgroundColor: "grey.300",
  },
};

export const dispatchFiltersSx = {
  mt: 2,
  mb: 2,
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    md: "1fr 1fr 1fr 1fr auto auto",
  },
  gap: 1.5,
  alignItems: "center",
};

export const dispatchTableSx = {
  border: 0,
  backgroundColor: "#fff",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "transparent",
    color: "#64748b",
    minHeight: "56px !important",
    maxHeight: "56px !important",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "transparent",
    color: "#64748b",
  },
  "& .MuiDataGrid-columnHeaderTitleContainer": {
    color: "#64748b",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    color: "#64748b",
    fontWeight: 700,
    whiteSpace: "normal",
    lineHeight: 1.2,
  },
  "& .MuiDataGrid-iconButtonContainer, & .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton":
    {
      color: "#64748b",
    },
  "& .MuiDataGrid-cell": {
    alignItems: "center",
  },
};

export const dispatchErrorSx = {
  minHeight: 180,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  px: 2,
};

export const dialogTitleSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  pb: 1.5,
};

export const dialogTitleTextSx = {
  fontSize: 18,
  fontWeight: 700,
};

export const dialogSubtitleSx = {
  mt: 0.5,
  fontSize: 13,
  overflowWrap: "anywhere",
};
